interface IModalNotification {
  titleKey: string;
  messageKey: string;
  identifier: string;
  element?: any;
}

export class ModalNotification {
  titleKey: string;
  messageKey: string;
  identifier: string;
  element?: any;

  constructor(notification?: IModalNotification) {
    this.titleKey = notification?.titleKey ?? "";
    this.messageKey = notification?.messageKey ?? "";
    this.identifier = notification?.identifier || "";
    this.element = notification?.element;
  }
}
